import type { IconType } from "ui";

export function validationIcon(valid: boolean): IconType {
  return valid ? "Check" : "Pending";
}
